import { connect } from "react-redux";
import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { Modal } from "react-bootstrap";
import AlertModal from "./AlertModal";
import "./Modal.css";
import "./ReviewDialog.css";
import DataBase from "../../dataBase/liquidGuides";
import Review from "../../Models/Review";
import Rating from "react-rating";

class ReviewDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rating: 3,
      comment: "",
      review: new Review(3, "", this.props.user_info),

      AlertModalShow: false,
      AlertModalTitle: "",
      AlertModalMessage: "",
      AlertModalButtons: [],
    };
    this.handleChangeComment = this.handleChangeComment.bind(this);
  }

  componentDidMount() {
    DataBase.reviewExists(this.props.guide_info_id, this.props.user_info.uid, this.reviewExistsCallback);
  }

  reviewExistsCallback = (res) => {
    if (res.pass == false) return;
    this.setState({ ...this.state, review: res.review, rating: res.review.rating, comment: res.review.comment });
  };

  submitReview = () => {
    let review = this.state.review;
    review.rating = this.state.rating;
    review.comment = this.state.comment;
    DataBase.addReviewTransaction(this.props.guide_info_id, review, this.submitReviewCallback);
    this.props.onHide();
  };

  submitReviewCallback = (res) => {
    if (res.pass == false) return;
  };

  handleChangeComment = (newText) => {
    this.setState({ ...this.state, comment: newText });
  };

  ratingCompleted = (rating) => {
    this.setState({ ...this.state, rating: rating });
  };

  render() {
    return (
      <div className="modal">
        <Modal
          {...this.props}
          animation={false}
          dialogClassName="rv-dialog"
          aria-labelledby="rv-title"
          centered
          onHide={this.props.onHide}
        >
          <Modal.Body style={{ padding: 0 }}>
            <div className="rv-shell">

              {/* ── Header ── */}
              <div className="rv-header">
                <div className="rv-header-icon">
                  <FontAwesomeIcon icon={solid("star")} />
                </div>
                <h2 className="rv-title" id="rv-title">Rate Guide</h2>
                <div className="rv-header-actions">
                  <button className="rv-submit" onClick={this.submitReview}>
                    <FontAwesomeIcon icon={solid("check")} />
                    Submit
                  </button>
                  <button className="rv-close" onClick={this.props.onHide}>
                    <FontAwesomeIcon icon={solid("xmark")} />
                  </button>
                </div>
              </div>

              {/* ── Body ── */}
              <div className="rv-body">
                <div className="rv-rating-row">
                  <span className="rv-label">Your Rating</span>
                  <div className="rv-stars">
                    <Rating
                      fractions={2}
                      initialRating={this.state.rating}
                      onChange={this.ratingCompleted}
                    />
                  </div>
                </div>
                <div className="rv-textarea-row">
                  <span className="rv-label">Comment</span>
                  <textarea
                    className="rv-textarea"
                    placeholder="Share your experience..."
                    value={this.state.comment}
                    onChange={(e) => this.handleChangeComment(e.target.value)}
                  />
                </div>
              </div>

            </div>
          </Modal.Body>
        </Modal>
        <AlertModal
          show={this.state.AlertModalShow}
          onHide={() => this.setState({ AlertModalShow: false })}
          AlertModalTitle={this.state.AlertModalTitle}
          AlertModalMessage={this.state.AlertModalMessage}
          AlertModalButtons={this.state.AlertModalButtons}
        />
      </div>
    );
  }
}

export default ReviewDialog;
